import { postJson1, postJson } from './axios'
const uploadPointUrl = process.env.VUE_APP_UPLOAD_POINT_URL ? process.env.VUE_APP_UPLOAD_POINT_URL : 'https://jdtest.yucrm.cn/yeion-operate-data/collection/uploadPointData'

/**
 * 埋点
 * @param {*} p 
 * @returns 
 */
export const uploadPointData = (p) => postJson1(uploadPointUrl, p);